import { executeRequest, Request } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'

export const getUPIIntentApi = (params: any) => {
  const URL = getAPIURL('upiIntent')
  const request: Request<{}> = {
    apiPath: URL,
    method: 'POST',
    headers: getPaymentHeader(),
    body: params,
  }
  return executeRequest(request).then((response) => {
    const { data } = response
    return data
  })
}

export const getUPIIntentRequest = (merchantId: string, amount: string, intentId: String) => ({
  data: {
    merchantId,
    type: 'DYNAMIC',
    qrInterfaceType: 'UPI',
    purpose: '00',
    amount,
    medium: 'APP',
    paymentAcceptance: ['526'],
    intentId,
  },
  config: {
    outputType: 'URI',
  },
})
